import 'reflect-metadata';
import { attribute, autoGeneratedHashKey } from '@awslabs-community-fork/dynamodb-data-mapper-annotations';
import { dynamicTableName } from '@pristine-ts/aws';
import { ClientQuestionnaireOptions } from '../options/client-questionnaire/client-questionnaire.options';
import { ClientQuestionnaireKeynameEnum } from '../enums/client-questionnaire/client-questionnaire-keyname.enum';
import { ClientQuestionnaireStatusEnum } from '../enums/client-questionnaire/client-questionnaire-status.enum';
import { property } from '@pristine-ts/metadata';

@dynamicTableName('CLIENT_QUESTIONNAIRE_TABLE_NAME')
export class ClientQuestionnaireModel {
  @autoGeneratedHashKey()
  @property()
  id: string;
  @attribute()
  @property()
  ownerId: string;
  @attribute()
  @property()
  organizationId: string;
  @attribute()
  @property()
  options: ClientQuestionnaireOptions;
  @attribute()
  @property()
  status: ClientQuestionnaireStatusEnum;
  @attribute()
  @property()
  keyname: ClientQuestionnaireKeynameEnum;
  @attribute()
  @property()
  clientName: string;
  @attribute()
  @property()
  clientIdentityId?: string;
  @attribute()
  @property()
  clientEmail?: string;
  @attribute()
  @property()
  createdAt: Date;
  @attribute()
  @property()
  updatedAt: Date;
}
